<template>
  <v-menu
    v-model="menu_ativo"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scroll-x-reverse-transition"
    :bottom="bottom"
    :left="left"
    min-width="auto"
  >
    <template #activator="{}">
      <v-text-field
        v-model="DATA_SELECIONADA"
        readonly
        v-bind="$attrs"
        @click="menu_ativo = true"
      />
    </template>

    <div>
      <v-date-picker
        v-model="DATA_SELECIONADA"
        :min="min"
        :max="max"
        color="#042333"
        v-bind="props_date_picker"
        @input="menu_ativo = false"
      />
    </div>
  </v-menu>
</template>

<script>
export default {
  name: "TextFieldDate",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: String,
    min: String,
    max: String,
    props_date_picker: Object,
    bottom: Boolean,
    left: Boolean,
  },
  data: () => ({
    menu_ativo: false,
  }),
  computed: {
    DATA_SELECIONADA: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit("update:modelValue", valor);
      }
    }
  }
}
</script>

<style scoped>

</style>
